import apiClient from "../../services/apiClient";
import { Company } from "./company";

export const loadCompanies = async (): Promise<Company[]> => {
  const response = await apiClient.get<Company[]>("/Company");
  return response.data;
};
